module.exports = __webpack_public_path__ + "img/09_fruit tote.9635a758.png";